import React, { useEffect, useState } from "react";
import { Accordion, Offcanvas } from "react-bootstrap";
import { getDisputeHistory, getDisputeMessage } from "../../utils/services";
import {
  APPEAL,
  APPEALER,
  DARK_THEME,
  DISPUTER,
  getHistoryDescription,
  OLYMPUS_AI,
  RESOLVER,
  WINNER_PROPOSAL_MODE,
} from "../../utils/constants";
import {
  formatFileSize,
  getBackgroundColor,
  getDateNTimeInSlashes,
  getFormatedWeb3Address,
} from "../../utils/helpers";
import { useRecoilValue } from "recoil";
import { userSmartAccount } from "../RecoilAtom";
import DisputeResponseTimer from "./DisputeResponseTimer";
import { useTheme } from "../../contexts/ThemeProvider";
import DisputeWindowTime from "./DisputeWindowTime";
import { useSwipeClose } from "../../hooks/useSwipeClose";

const EvidenceFileMenu = ({
  poolId,
  poolOwnerWalletAddress,
  setShowCreateDisputeOffCanvas,
  showevidence,
  setShowEvidence,
  setIsCreatorResponding,
  showevidenHistory: showEvidenceHistory,
  profilePic,
  resolverAddress,
  claimNotDisputed,
  claimEligibility,
  setClaimNotDisputed,
  disputeOrAppealText,
  setWinnerProposalMode,
  decideWinnerTime,
  isClaimWindowOpen,
  poolsdetail,
  isUnderDispute,
}) => {
  const { theme } = useTheme();
  const smartAccount = useRecoilValue(userSmartAccount);
  const [evidenceListing, setEvidenceListing] = useState([]);
  const [historyGroups, setHistoryGroups] = useState([]);
  const [timeLeftInResponse, setTimeLeftInResponse] = useState(false);
  const [collapseIndex, setCollapseIndex] = useState(0);
  const handleCloseEvidence = () => setShowEvidence(false);
  const handleShowResponseWindow = () => {
    setShowEvidence(false);
    setShowCreateDisputeOffCanvas(true);
    setIsCreatorResponding(true);
  };

  const swipeRef = useSwipeClose(showevidence, handleCloseEvidence);

  const fetchEvidenceListing = async () => {
    try {
      const data = await getDisputeMessage(poolId);
      setEvidenceListing(data);
    } catch (error) {
      console.log("error in getting dispute data:", error);
    }
  };

  const fetchHistoryListing = async () => {
    try {
      const data = await getDisputeHistory(poolId);
      const updatedHistory = (data || []).map((group) => {
        const events = group?.events || [];
        if (!events.length) return group;

        const firstEvent = events[0];
        const hasTooEarly = events.some(e => e?.type === "resolution" && e?.stage === "too-early");
        let newEvents = (!hasTooEarly && (firstEvent?.role === "appealer" || firstEvent?.role === "disputer"))
          ? [{
            type: "resolution",
            stage: "waiting",
            winnerOption: null,
            decidedBy: OLYMPUS_AI,
            createdAt: new Date().toISOString(),
          }, ...events]
          : [...events];

        if (!hasTooEarly) {
          newEvents = newEvents?.flatMap((event, i) => {
            if (event?.stage !== "appeal-resubmitted") return [event];
            const newerEvent = newEvents[i - 1];
            return newerEvent?.stage === "system-error"
              ? [event]
              : [
                {
                  type: "resolution",
                  stage: "waiting",
                  isResubmitWaiting: true,
                  winnerOption: null,
                  decidedBy: OLYMPUS_AI,
                  createdAt: new Date().toISOString(),
                },
                event,
              ];
          });
        }

        return { ...group, events: newEvents };
      });

      setHistoryGroups(updatedHistory);
    } catch (error) {
      console.log("error in getting dispute History:", error);
    }
  };

  useEffect(() => {
    if (!showevidence) return;
    if (!showEvidenceHistory) {
      fetchEvidenceListing();
    } else {
      fetchHistoryListing();
    }
  }, [showevidence, showEvidenceHistory]);
  const hasCreatorRole = evidenceListing?.some((item) => item?.role === "creator") || false;


  const OlympusLogo = () =>
    theme === DARK_THEME ? (
      <img src="\assets\olympuslogo.svg" alt="img" className="img-fluid" style={{ maxWidth: "120px" }} />
    ) : (
      <img src="\assets\olympuslogolight.svg" alt="img" className="img-fluid" style={{ maxWidth: "120px" }} />
    );
  const ReasoningAccordion = ({ explanation }) => {
    const [openReasoning, setOpenReasoning] = useState(false);

    return (
      <>
        <a
          onClick={(e) => {
            e.stopPropagation();
            setOpenReasoning(!openReasoning);
          }}
          className="disputenumber m-0"
          style={{ gap: "6px", textDecoration: "none", cursor: "pointer", paddingBottom: openReasoning ? "15px" : "" }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            style={{
              rotate: openReasoning ? "0deg" : "180deg",
              transition: "0.1s ease-in-out",
            }}
          >
            <path
              d="M4 10L8 6L12 10"
              stroke="currentColor"
              strokeWidth="1.33333"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg> {openReasoning ? "Hide" : "View"} reasoning
        </a>

        {openReasoning && (
          <div className="evidence-parent viewreasoning_ui w-100">
            <div
              className="single-evidence"
              style={{ padding: "0", backgroundColor: "transparent", border: "none" }}
            >
              <div className="evidence-file-parent">
                <div
                  className="bottom-box"
                  dangerouslySetInnerHTML={{ __html: explanation }}
                />
              </div>
            </div>
          </div>
        )}
      </>
    );
  };

  return (
    <Offcanvas
      placement={window.innerWidth > 991 ? "end" : "bottom"}
      className="reasoningoffcanvas new-offcanvas-style-mobile"
      show={showevidence}
      onHide={handleCloseEvidence}
    >
      {
        window.innerWidth > 991 ? (
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>
              {showEvidenceHistory ? "History" : "Evidence Files"}
            </Offcanvas.Title>
            <span className='mobile-swap-close d-none'></span>
          </Offcanvas.Header>
        ) : (
          <Offcanvas.Header ref={swipeRef}>
            <span className='mobile-swap-close d-none'></span>
          </Offcanvas.Header>
        )
      }
      <Offcanvas.Body>
        {showEvidenceHistory ? (
          <div className="historyacc">
            <Accordion className="upperacc">
              {historyGroups?.map((group, index) => {
                const events = group?.events || [];

                const disputes = events?.filter((e) => e?.type === "message");
                const resolution = events?.find(
                  (e) => e?.type === "resolution" && e?.stage === "disputed"
                ) || events?.find(
                  (e) => e?.type === "resolution" && e?.stage === "appealed"
                );
                const initialResolution = events?.find((e) => e?.type === "resolution" && e?.stage === "initial");
                const tooEarlyResolution = events?.find((e) => e?.type === "resolution" && e?.stage === "too-early");
                const displayResolution = resolution || initialResolution;
                const proposer = initialResolution || resolution;
                const isAiResolver = poolsdetail?.isAiResolver;
                const hasBodyContent = (disputes && disputes?.length > 0) || (isAiResolver && !!proposer?.explanation);

                {
                  if (tooEarlyResolution) {
                    return (
                      <Accordion.Item key={index} eventKey={String(index)} className="upperaccitem tooearly-scenerio disabled-arrow-tooearlycase">
                        <Accordion.Header className="upperacchead">
                          <div className="mainacc">
                            <div className="inneracc">
                              <div className="statusmain">
                                <p className="statuspara tooearly">Too Early</p>
                                <p className="datepara">{getDateNTimeInSlashes(tooEarlyResolution?.createdAt)}</p>
                              </div>
                              <div className="resolved-by-early">
                                <p className="proposepara">Resolved by</p>
                                {
                                  theme === DARK_THEME ? <img src='\assets\olympus-outcomedark.svg' alt='img' className='img-fluid' style={{ maxWidth: "120px" }} /> :
                                    <img src='\assets\olympus-outcome.svg' alt='img' className='img-fluid' style={{ maxWidth: "120px" }} />
                                }
                              </div>
                            </div>
                            <div className="loweracc">
                              <p className="proposepara">Triggered by:</p>
                              <div className="mainname">
                                <div className="profileimg">
                                  <img src={tooEarlyResolution?.winnerProposer?.profilePic || "/assets/omp-icon.svg"} alt="innerimg" className="innerimg" />
                                </div>
                                <p className="namehead">
                                  {tooEarlyResolution?.winnerProposer?.username?.trim()
                                    ? tooEarlyResolution.winnerProposer.username
                                    : tooEarlyResolution?.winnerProposer?.walletAddress
                                      ? getFormatedWeb3Address(tooEarlyResolution?.winnerProposer?.walletAddress, true)
                                      : "Olympus AI"}
                                </p>
                                {tooEarlyResolution?.winnerProposer?.role && (
                                  <span className="mainspan">
                                    {tooEarlyResolution.winnerProposer.role}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        </Accordion.Header>
                        <Accordion.Body className="accordionbodyemptybody"></Accordion.Body>
                      </Accordion.Item>
                    );
                  }
                }

                // Normal resolution render (existing code - no changes)
                return (
                  <Accordion.Item
                    key={index}
                    eventKey={String(index)}
                    className={isAiResolver ? "upperaccitem tooearly-scenerio" : "upperaccitem"}
                  >
                    <Accordion.Header className={!hasBodyContent ? "upperacchead accordionbodyempty" : "upperacchead"}>
                      <div className="mainacc">
                        <div className="inneracc" style={isAiResolver ? { borderBottom: "1px solid transparent" } : {}}>
                          {isAiResolver ? (
                            <>
                              <div className="statusmain">
                                <div className="countrymain">
                                  <span
                                    className="circle"
                                    style={{
                                      backgroundColor: getBackgroundColor(
                                        poolsdetail?.options?.findIndex(
                                          (opt) => opt._id === initialResolution?.winnerOption?.optionId
                                        ),
                                        theme,
                                        poolsdetail?.options?.length
                                      ),
                                    }}
                                  ></span>
                                  <p className="countrytext">
                                    {initialResolution?.winnerOption?.optionName ?? "—"}
                                  </p>
                                </div>
                                <p className="datepara">
                                  {getDateNTimeInSlashes(displayResolution?.createdAt)}
                                </p>
                              </div>
                              <div className="resolved-by-early">
                                <p className="proposepara">Resolved by</p>
                                {theme === DARK_THEME ? (
                                  <img src='\assets\olympus-outcomedark.svg' alt='img' className='img-fluid' style={{ maxWidth: "120px" }} />
                                ) : (
                                  <img src='\assets\olympus-outcome.svg' alt='img' className='img-fluid' style={{ maxWidth: "120px" }} />
                                )}
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="countrymain">
                                <span
                                  className="circle"
                                  style={{
                                    backgroundColor: getBackgroundColor(
                                      poolsdetail?.options?.findIndex(
                                        (opt) => opt._id === initialResolution?.winnerOption?.optionId
                                      ),
                                      theme,
                                      poolsdetail?.options?.length
                                    ),
                                  }}
                                ></span>
                                <p className="countrytext">
                                  {initialResolution?.winnerOption?.optionName ?? "—"}
                                </p>
                              </div>
                              <div className="statusmain">
                                <p className={`statuspara ${index === 0 ? "aprroved" : "rejected"}`}>
                                  {index !== 0 ? "Too Early" : "Approved"}
                                </p>
                                <p className="datepara">
                                  {getDateNTimeInSlashes(displayResolution?.createdAt)}
                                </p>
                              </div>
                            </>
                          )}
                        </div>
                        {!isAiResolver && (
                          <div className="loweracc">
                            <p className="proposepara">Proposed By:</p>
                            <div className="mainname">
                              {(() => {
                                const proposer = initialResolution || resolution;
                                return (
                                  <>
                                    <div className="profileimg">
                                      <img
                                        src={
                                          proposer?.winnerProposer?.profilePic ||
                                          (proposer?.winnerOption?.decidedBy === RESOLVER
                                            ? profilePic
                                            : "/assets/omp-icon.svg")
                                        }
                                        alt="innerimg"
                                        className="innerimg"
                                      />
                                    </div>
                                    <p className="namehead">
                                      {proposer?.winnerProposer?.username?.trim()
                                        ? proposer.winnerProposer.username
                                        : proposer?.winnerProposer?.walletAddress
                                          ? getFormatedWeb3Address(proposer?.winnerProposer?.walletAddress, true)
                                          : proposer?.winnerOption?.decidedBy !== RESOLVER
                                            ? "Olympus AI"
                                            : getFormatedWeb3Address(resolverAddress, true)}
                                    </p>
                                    {proposer?.winnerOption?.decidedBy === RESOLVER && (
                                      <span className="mainspan">
                                        {proposer?.winnerProposer?.role === "creator"
                                          ? "Market Creator"
                                          : proposer?.winnerProposer?.role === "Participant"
                                            ? "Participant"
                                            : "Proposer"}
                                      </span>
                                    )}
                                  </>
                                );
                              })()}
                            </div>
                          </div>
                        )}
                      </div>
                    </Accordion.Header>
                    {/*
                     {proposer?.winnerOption?.decidedBy !== RESOLVER &&
                      proposer?.explanation && (
                        <div
                          className="accordion-body pt-2"
                          style={{ padding: "0 16px 12px" }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <ReasoningAccordion explanation={proposer?.explanation} />
                        </div>
                      )
                    } */}
                    <Accordion.Body className={!hasBodyContent ? "accordionbodyemptybody" : ""}>
                      {isAiResolver && (
                        <div className="loweracc">
                          <p className="proposepara">Triggered by:</p>
                          <div className="mainname">
                            {(() => {
                              const proposer = initialResolution || resolution;
                              return (
                                <>
                                  <div className="profileimg">
                                    <img
                                      src={
                                        proposer?.winnerProposer?.profilePic ||
                                        (proposer?.winnerOption?.decidedBy === RESOLVER
                                          ? profilePic
                                          : "/assets/omp-icon.svg")
                                      }
                                      alt="innerimg"
                                      className="innerimg"
                                    />
                                  </div>
                                  <p className="namehead">
                                    {proposer?.winnerProposer?.username?.trim()
                                      ? proposer.winnerProposer.username
                                      : proposer?.winnerProposer?.walletAddress
                                        ? getFormatedWeb3Address(proposer?.winnerProposer?.walletAddress, true)
                                        : proposer?.winnerOption?.decidedBy !== RESOLVER
                                          ? "Olympus AI"
                                          : getFormatedWeb3Address(resolverAddress, true)}
                                  </p>
                                  {proposer?.winnerProposer?.role && (
                                    <span className="mainspan">
                                      {proposer?.winnerProposer?.role === "creator"
                                        ? "Market Creator"
                                        : proposer?.winnerProposer?.role?.toLowerCase() === "participant"
                                          ? "Participant"
                                          : "Proposer"}
                                    </span>
                                  )}
                                </>
                              );
                            })()}
                          </div>
                        </div>
                      )}
                      {isAiResolver && proposer?.explanation && (
                        <div className="evidence-parent viewreasoning_ui w-100">
                          <div
                            className="single-evidence"
                            style={{ padding: "0", backgroundColor: "transparent", border: "none" }}
                          >
                            <div className="evidence-file-parent evidence-file-parent-resolvedaicase">
                              <div
                                className="bottom-box"
                                style={{ maxHeight: "300px", overflowY: "auto" }}
                                dangerouslySetInnerHTML={{ __html: proposer?.explanation }}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                      {disputes?.length > 0 && (
                        <a
                          onClick={() => setCollapseIndex(collapseIndex === index ? null : index)}
                          style={{ marginBottom: collapseIndex === index ? "18px" : "0", paddingTop: "18px", borderTop: "1px solid var(--modal-border)" }}
                          className="disputenumber"
                        >
                          {disputes?.length} dispute{disputes.length !== 1 ? "s" : ""}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            style={{
                              rotate: collapseIndex === index ? "0deg" : "180deg",
                              transition: "0.1s ease-in-out",
                            }}
                          >
                            <path
                              d="M4 10L8 6L12 10"
                              stroke="#111111"
                              strokeWidth="1.33333"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>

                        </a>
                      )}

                      {collapseIndex === index && (
                        <div className="dispute-history-parent">
                          <Accordion defaultActiveKey={["0"]} alwaysOpen>
                            {group?.events?.slice()?.reverse()?.map((item, i) => {
                              return (
                                <>
                                  {item?.type === "message" ? (
                                    <Accordion.Item
                                      key={i}
                                      eventKey={String(i)}
                                      style={item?.role === APPEALER ? { pointerEvents: "none" } : {}}
                                    >
                                      <div className="checkmark">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                          <path d="M11.6663 3.5L5.24967 9.91667L2.33301 7" stroke="#DAD9D9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                      </div>
                                      <Accordion.Header className={item?.role === APPEALER ? "marketcreatedaccordionui" : ""}>
                                        <div className="main-title">
                                          <div className="profile-img">
                                            <img src={item?.sender?.profilePic} alt="img" className="img-fluid" />
                                          </div>
                                          <h6>
                                            <span className="forspecificompai">
                                              {getFormatedWeb3Address(item?.senderWalletAddress, true)} (
                                              {item?.senderWalletAddress?.toLowerCase() === poolOwnerWalletAddress?.toLowerCase()
                                                ? "Market Creator"
                                                : "Participant"}
                                              )
                                            </span>
                                            {" "}
                                            <span>{getHistoryDescription[item?.role]}</span>
                                          </h6>
                                        </div>
                                      </Accordion.Header>
                                      <Accordion.Body>
                                        <div className="evidence-parent">
                                          {item?.evidence?.options && (
                                            <div className="mainoutcome">
                                              <p className="outcomepara">Disputed Outcome</p>
                                              <div className="countrymain">
                                                <span className="circle"></span>
                                                <p className="countrytext">{item?.evidence?.options?.[0] ?? "—"}</p>
                                              </div>
                                            </div>
                                          )}
                                          <div className="single-evidence" style={{ padding: "0", backgroundColor: "transparent", border: "none" }}>
                                            <h5>{item?.evidence?.question}</h5>
                                            <p className="para">{item?.evidence?.description}</p>
                                            <div className="evidence-file-parent">
                                              {item?.aiAnalysis?.results?.length > 0 && item.aiAnalysis.results.map((result, ri) => (
                                                <div className="single-file" key={ri}>
                                                  <div className="left-side">
                                                    <div className="main-img">
                                                      <img src={result?.evidenceData?.cloudinaryUrl} alt="img" className="img-fluid" />
                                                    </div>
                                                    <div className="text">
                                                      <h6>{result?.evidenceData?.fileName}</h6>
                                                      <p>{result?.evidenceData?.cloudinaryFormat} | {formatFileSize(result?.evidenceData?.fileSize)}</p>
                                                    </div>
                                                  </div>
                                                  <a className="btn-download" href="#" onClick={(e) => e.preventDefault()}>
                                                    <svg
                                                      onClick={() => window.open(result?.evidenceData?.cloudinaryUrl, "_blank", "noopener,noreferrer")}
                                                      xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"
                                                    >
                                                      <path d="M10 12.5V2.5" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                      <path d="M17.5 12.5V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V12.5" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                      <path d="M5.83333 8.33337L9.99999 12.5L14.1667 8.33337" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                  </a>
                                                </div>
                                              ))}
                                              <p className="date-text">{getDateNTimeInSlashes(item?.createdAt)}</p>
                                            </div>
                                          </div>
                                        </div>
                                      </Accordion.Body>
                                      {item?.role === APPEALER && (
                                        <div className="accordion-body bodyaccordionalwaysvisible">
                                          <div className="evidence-parent">
                                            <div className="single-evidence" style={{ padding: "0", backgroundColor: "transparent", border: "none" }}>
                                              <div className="evidence-file-parent">
                                                <p className="date-text m-0">{getDateNTimeInSlashes(item?.createdAt)}</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </Accordion.Item>
                                  ) : item?.stage === "waiting" ? (
                                    <Accordion.Item
                                      className="setdisabledappealreviewd"
                                      style={{ pointerEvents: "none" }}
                                      eventKey={i}
                                    >
                                      <div className="checkmark">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                          <path d="M7.0013 11.6665C8.23898 11.6665 9.42596 11.1748 10.3011 10.2997C11.1763 9.4245 11.668 8.23751 11.668 6.99984C11.668 5.76216 11.1763 4.57518 10.3011 3.70001C9.42596 2.82484 8.23898 2.33317 7.0013 2.33317C5.76363 2.33317 4.57664 2.82484 3.70147 3.70001C2.8263 4.57518 2.33464 5.76216 2.33464 6.99984C2.33464 8.23751 2.8263 9.4245 3.70147 10.2997C4.57664 11.1748 5.76363 11.6665 7.0013 11.6665ZM7.0013 1.1665C7.76735 1.1665 8.52589 1.31739 9.23362 1.61054C9.94136 1.90369 10.5844 2.33337 11.1261 2.87505C11.6678 3.41672 12.0974 4.05978 12.3906 4.76752C12.6838 5.47525 12.8346 6.23379 12.8346 6.99984C12.8346 8.54693 12.2201 10.0307 11.1261 11.1246C10.0321 12.2186 8.5484 12.8332 7.0013 12.8332C3.77547 12.8332 1.16797 10.2082 1.16797 6.99984C1.16797 5.45274 1.78255 3.96901 2.87651 2.87505C3.97047 1.78109 5.45421 1.1665 7.0013 1.1665ZM7.29297 4.08317V7.14567L9.91797 8.70317L9.48047 9.42067L6.41797 7.58317V4.08317H7.29297Z" fill="#DAD9D9" />
                                        </svg>
                                      </div>
                                      <Accordion.Header>
                                        <div className="main-title">
                                          <h6>
                                            <span>

                                              {item?.isResubmitWaiting
                                                ? "Appeal is being reviewed by "
                                                : disputes[0]?.role === "appealer"
                                                  ? "Appeal is being reviewed by "
                                                  : "Dispute being reviewed by "}
                                              <OlympusLogo />
                                            </span>
                                          </h6>
                                        </div>
                                      </Accordion.Header>
                                    </Accordion.Item>
                                  ) : item?.stage === "system-error" ? (
                                    <Accordion.Item
                                      className="setdisabledappealreviewd"
                                      style={{ pointerEvents: "none" }}
                                      eventKey={String(i)}
                                    >
                                      <div className="checkmark">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                          <path d="M11.6663 3.5L5.24967 9.91667L2.33301 7" stroke="#FE5C32" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                      </div>
                                      <Accordion.Header className="marketcreatedaccordionui">
                                        <div className="main-title w-100">
                                          <div className="profile-img">
                                            <img src="\assets\detailpage\ethosicon.svg" alt="img" />
                                          </div>
                                          <h6>
                                            <span className="forspecificompai forspecificompaimblblock">
                                              System Error
                                            </span>{" "}
                                            Ethos review timeout
                                          </h6>
                                        </div>
                                      </Accordion.Header>
                                      <div className="accordion-body bodyaccordionalwaysvisible">
                                        <div className="evidence-parent">
                                          <div className="single-evidence" style={{ padding: "0", backgroundColor: "transparent", border: "none" }}>
                                            <div className="evidence-file-parent">
                                              <div style={{
                                                backgroundColor: "rgba(219, 95, 43, 0.10)",
                                                border: "1px solid transparent",
                                                borderRadius: "8px",
                                                padding: "10px 14px",
                                                marginBottom: "6px",
                                                display: "flex",
                                                alignItems: "flex-start",
                                                gap: "5px"
                                              }}>
                                                <svg style={{ flexShrink: "0" }} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                  <g clip-path="url(#clip0_2215_1466)">
                                                    <path d="M9.99984 18.3337C14.6022 18.3337 18.3332 14.6027 18.3332 10.0003C18.3332 5.39795 14.6022 1.66699 9.99984 1.66699C5.39746 1.66699 1.6665 5.39795 1.6665 10.0003C1.6665 14.6027 5.39746 18.3337 9.99984 18.3337Z" stroke="#DB5F2B" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M10 6.66699V10.0003" stroke="#DB5F2B" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M10 13.333H10.0083" stroke="#DB5F2B" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                  </g>
                                                  <defs>
                                                    <clipPath id="clip0_2215_1466">
                                                      <rect width="20" height="20" fill="white" />
                                                    </clipPath>
                                                  </defs>
                                                </svg>
                                                <p style={{ color: "#DB5F2B", margin: "0", fontSize: "13px" }}>
                                                  {item?.explanation}
                                                </p>
                                              </div>
                                              <p className="date-text m-0">{getDateNTimeInSlashes(item?.createdAt)}</p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Accordion.Item>
                                  ) : item?.stage === "appeal-resubmitted" ? (
                                    <Accordion.Item
                                      className="setdisabledappealreviewd"
                                      style={{ pointerEvents: "none" }}
                                      eventKey={String(i)}
                                    >
                                      <div className="checkmark">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                          <path d="M11.6663 3.5L5.24967 9.91667L2.33301 7" stroke="#DAD9D9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                      </div>
                                      <Accordion.Header className="marketcreatedaccordionui">
                                        <div className="main-title w-100">
                                          <div className="profile-img">
                                            <img src="https://dh3bzuu7a45gi.cloudfront.net/gems/creator/81eacfe1d71041249a196234f5c5686e.jpeg" alt="img" className="img-fluid" />
                                          </div>
                                          <h6>
                                            <span className="forspecificompai forspecificompaimblblock">
                                              Resubmitted Appeal
                                            </span>{" "}
                                            attempt #{
                                              group?.events
                                                ?.slice()
                                                ?.reverse()
                                                ?.slice(0, i + 1)
                                                ?.filter(e => e?.stage === "appeal-resubmitted")
                                                ?.length
                                            }
                                          </h6>
                                        </div>
                                      </Accordion.Header>
                                      <div className="accordion-body bodyaccordionalwaysvisible">
                                        <div className="evidence-parent">
                                          <div className="single-evidence" style={{ padding: "0", backgroundColor: "transparent", border: "none" }}>
                                            <div className="evidence-file-parent">
                                              <p className="date-text m-0">{getDateNTimeInSlashes(item?.createdAt)}</p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </Accordion.Item>
                                  ) :
                                    item?.stage !== "initial" ? (
                                      <Accordion.Item
                                        className={
                                          resolution?.winnerOption?.decidedBy !== RESOLVER || isClaimWindowOpen
                                            ? ""
                                            : "makedispute-reviewed"
                                        }
                                        eventKey={i}
                                      >
                                        <div className="checkmark">
                                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                            <path d="M11.6663 3.5L5.24967 9.91667L2.33301 7" stroke="#DAD9D9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                          </svg>
                                        </div>
                                        <Accordion.Header>
                                          <div className="main-title">
                                            <div className="profile-img">
                                              <img src="/assets/omp-icon.svg" />
                                            </div>
                                            <h6>
                                              <span className="forspecificompai forspecificompaimblblock"> Olympus AI</span> reviewed and decided the final outcome{" "}
                                            </h6>
                                          </div>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                          {item?.winnerOption && (
                                            <>
                                              <div className="mainoutcome">
                                                <p className="outcomepara">Decided Outcome</p>
                                                <div className="countrymain">
                                                  <span
                                                    className="circle"
                                                    style={{
                                                      backgroundColor: getBackgroundColor(
                                                        poolsdetail?.options?.findIndex(
                                                          (opt) => opt._id === item?.winnerOption?.optionId
                                                        ),
                                                        theme,
                                                        poolsdetail?.options?.length
                                                      ),
                                                    }}
                                                  ></span>
                                                  <p className="countrytext">{item?.winnerOption?.optionName}</p>
                                                </div>
                                                {item?.explanation && item?.winnerOption?.decidedBy !== RESOLVER && (
                                                  <ReasoningAccordion explanation={item?.explanation} />
                                                )}
                                              </div>
                                              {isClaimWindowOpen && claimNotDisputed && disputeOrAppealText === APPEAL && (
                                                <button
                                                  onClick={() => {
                                                    setWinnerProposalMode(WINNER_PROPOSAL_MODE.APPEAL);
                                                    setShowCreateDisputeOffCanvas(true);
                                                  }}
                                                  className="appealbtn"
                                                  style={{ marginTop: "20px", marginBottom: "0" }}
                                                >
                                                  <h6 className="createpara">
                                                    CREATE Appeal
                                                    <DisputeWindowTime
                                                      claimNotDisputed={claimNotDisputed}
                                                      decideWinnerEndTime={decideWinnerTime}
                                                      claimEligibility={claimEligibility}
                                                      setClaimNotDisputed={setClaimNotDisputed}
                                                      disputeOrAppealText={disputeOrAppealText}
                                                    />
                                                  </h6>
                                                </button>
                                              )}
                                              <p className="date-text">{getDateNTimeInSlashes(resolution?.createdAt)}</p>
                                            </>
                                          )}
                                        </Accordion.Body>
                                      </Accordion.Item>
                                    ) : (
                                      ""
                                    )}
                                </>
                              );
                            })}
                          </Accordion>
                        </div>
                      )}
                    </Accordion.Body>
                  </Accordion.Item>
                );
              })}
            </Accordion>
          </div>
        ) : (
          <>
            <div className="evidence-parent">
              {evidenceListing?.map((item, index) => (
                <div key={index} className="single-evidence mb-2">
                  <div className="upper-field">
                    <div className="profile">
                      <img src={item?.sender?.profilePic} alt="img" className="img-fluid" />
                    </div>
                    {item?.role === DISPUTER ? (
                      <h6>
                        {item?.sender?.name ? item?.sender?.name : getFormatedWeb3Address(item?.sender?.walletAddress, true)}{" "}
                        (Participant) <span>Created a Dispute</span>
                      </h6>
                    ) : (
                      <h6>
                        {item?.sender?.name ? item?.sender?.name : getFormatedWeb3Address(item?.sender?.walletAddress, true)}{" "}
                        (Creator) <span>Responded to a Dispute</span>
                      </h6>
                    )}
                  </div>
                  <h5>{item?.evidence?.question}</h5>
                  <p className="para">{item?.evidence?.description}</p>
                  <div className="evidence-file-parent">
                    {item?.aiAnalysis?.results?.length > 0 && item.aiAnalysis.results.map((result, i) => (
                      <div className="single-file" key={i}>
                        <div className="left-side">
                          <div className="main-img">
                            <img src={result?.evidenceData?.cloudinaryUrl} alt="img" className="img-fluid" />
                          </div>
                          <div className="text">
                            <h6>{result?.evidenceData?.fileName}</h6>
                            <p>{result?.evidenceData?.cloudinaryFormat} | {formatFileSize(result?.evidenceData?.fileSize)}</p>
                          </div>
                        </div>
                        <a className="btn-download" href="#" onClick={(e) => e.preventDefault()}>
                          <svg
                            onClick={() => window.open(result?.evidenceData?.cloudinaryUrl, "_blank", "noopener,noreferrer")}
                            xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"
                          >
                            <path d="M10 12.5V2.5" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M17.5 12.5V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V12.5" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M5.83333 8.33337L9.99999 12.5L14.1667 8.33337" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </a>
                      </div>
                    ))}
                    <p className="date-text">{getDateNTimeInSlashes(item?.createdAt)}</p>
                  </div>
                </div>
              ))}

              {!hasCreatorRole && (
                <DisputeResponseTimer
                  time={evidenceListing}
                  hasCreatorRole={hasCreatorRole}
                  setTimeLeftInResponse={setTimeLeftInResponse}
                />
              )}
            </div>
          </>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default EvidenceFileMenu;